// app/components/AdminButtonLayout.tsx

'use client'; // This component must be a Client Component

import { useState, useEffect, ReactNode } from 'react';
import dynamic from 'next/dynamic';

// 1. Use next/dynamic to create a component that will be loaded on demand.
//    The 'loading' option provides a temporary placeholder (here, nothing).
const DynamicEditButton = dynamic(
  () => import('./EditButtonLoader'), // Adjust the path to your component
  { ssr: false } // We don't need this on the server for a static site
);

interface AdminButtonLayoutProps {
  postId: string | number;
  children: ReactNode;
}

const AdminButtonLayout = ({ postId, children }: AdminButtonLayoutProps) => {
  // 2. State to track if the button should be shown.
  const [showButton, setShowButton] = useState(false);

  // 3. On component mount, check for the cookie.
  useEffect(() => {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('editing_check_enable='))
      ?.split('=')[1];

    if (cookieValue === 'true') {
      setShowButton(true);
    }
    // The empty array [] means this effect runs only once on the client.
  }, []);

  return (
    <>
      {children}
      {/* 4. If showButton is true, React will render the dynamic component. */}
      {/* This is the moment the browser will download its JavaScript. */}
      {showButton && <DynamicEditButton id={postId} />}
    </>
  );
};

export default AdminButtonLayout;